/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-FocusTrapZoneBoxExample{border:dashed 1px #ababab}.ms-FocusTrapComponent{border:#000 2px solid;padding:5px}"}]);
/* tslint:enable */